import React from 'react'
import Loader from './Loader'

function FillLoader() {
  return (
    <div className='w-full flex items-center justify-center'>
      <Loader />
    </div>
  )
}

export default FillLoader
